import { IDataFlowArguments, generateGrammarForColumns } from 'app/model/dataflow/dataflow-expression-utilities';
import { ModelMarkerProvider } from 'app/authoring/component/transformations/transformation-expression-builder/model.marker.provider';
import { DataFlow } from 'app/model/dataflow/dataflow';
import { ColumnReference } from 'app/model/dataset/columnReference';
import { ParameterValue } from 'app/model/base/parameter-value';
import { updateIdentifiers } from 'app/model/dataflow/dataflow-expression-update-identifiers';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { IDataFlowDataType } from 'app/model/dataflow/dataflow-datatype';
import { DataFlowTypesUtils } from 'app/model/dataflow/dataflow-type-utilities';
import { Owned } from 'shell-models-lib';

export function getExpressionReturnTypeAndUpdateIdentifiers(expression: string, args: IDataFlowArguments, entity?: Owned): IDataFlowDataType {
    if (entity instanceof DataFlowExpression) {
        updateIdentifiers(args, entity);
        return entity.returnType;
    } else {
        const modelMarkerProvider = new ModelMarkerProvider(args);
        modelMarkerProvider.evaluate(expression);
        return modelMarkerProvider.getExpressionReturnType();
    }
}

export function getDataFlowExpressionErrors(expression: string, args: IDataFlowArguments, entity?: Owned): string[] {
    if (entity instanceof DataFlowExpression) {
        return entity.getExpressionErrors();
    } else {
        const modelMarkerProvider = new ModelMarkerProvider(args);
        modelMarkerProvider.evaluate(expression);
        const errors = modelMarkerProvider.getErrors();
        return errors && errors.map((e) => e.message);
    }
}

export function getDataFlowExpressionWarnings(expression: string, args: IDataFlowArguments, entity?: Owned): string[] {
    if (entity instanceof DataFlowExpression) {
        return entity.getExpressionWarnings();
    } else {
        const modelMarkerProvider = new ModelMarkerProvider(args);
        modelMarkerProvider.evaluate(expression);
        const warnings = modelMarkerProvider.getWarnings();
        return warnings && warnings.map((w) => w.message);
    }
}

export function getDataFlowBaseArguments(dataFlow: DataFlow): IDataFlowArguments {
    if (!dataFlow) {
        return {
            dataFlowFunctions: [],
            dataFlowColumns: [],
            dataFlowParameters: [],
            dataFlowTransientColumns: [],
            dataFlowCacheSinks: []
        };
    }
    const columns: ColumnReference[] = [];
    dataFlow.sources?.forEach((source) => {
        columns.push(...source.distinctOutputColumnRefs);
    });
    dataFlow.transformations?.forEach((transformation) => {
        columns.push(...transformation.distinctOutputColumnRefs);
    });
    dataFlow.sinks?.forEach((sink) => {
        columns.push(...sink.distinctOutputColumnRefs);
    });
    columns.sort((a, b) => {
        return a.originalName < b.originalName ? 1 : -1;
    });
    const uniqueColumns: ColumnReference[] = [];
    columns.forEach((col, index) => {
        if (!uniqueColumns.length || uniqueColumns[uniqueColumns.length - 1].name !== col.name) {
            uniqueColumns.push(col);
        }
    });
    return generateGrammarForColumns(uniqueColumns, dataFlow.cacheSinks, dataFlow.parameters, null, null, true, true);
}

export function checkForEmptyValuetypes(param: ParameterValue, args: IDataFlowArguments): void {
    if (!param.valueType) {
        param.valueType = ParameterValue.VALUE.templateValue(param)
            ? 'string'
            : DataFlowTypesUtils.getFullParameterType(getExpressionReturnTypeAndUpdateIdentifiers(param.value, args));
    }
}
